module.exports = __webpack_public_path__ + "img/8.c8a604d7.png";